import React from 'react';
// import Header from './Header';
// import Footer from './Footer';

const SocialActivities = () => {
  return (
    <>
      {/* <Header /> */}

      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
        {/* <div className="breadcumb-wrapper" data-bg-src="assets/img/hero/slider1.jpg"> */}
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Social Activities </h1>
          </div>
        </div>
      </div>
      <section className="bg-theme overflow-hidden space overflow-hidden" data-bg-src="assets/img/bg/event-shape.html">
        <div className="container">

          <div className="row gy-4 gx-40">

            <div className="col-12">
              <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                <div className="box-wrapper">
                  <div className="box-wrapp">
                    <div className="num">
                      <h2 className="box-number">01</h2>
                    </div>
                    <div className="box-content">
                      <h3 className="box-title">
                        <a href="#">SHIVA DEEKSHA PROGRAMME </a>
                      </h3>
                      <p className="box-text">
                        The Glories of Guru Upadesha are boundless. Initiation from a Sadguru is a very rare treasure and indeed the
                        greatest boon of life. Guru Upadesha becomes the best Saadhana to achieve Chittha Shudhhi (internal purity). It
                        breaks the cage of worldliness and leads to the Supreme Atma Gnyaana. <br />
                        The Shiva Deeksha program is a unique initiative that reveals MahaSwamiji’s compassion and care to enlighten
                        individuals and nurture his/her sense of belonging to Sanatana Dharma. In the ShivaDeeksha Programme,
                        MahaSwamiji blesses people with the sacred ‘Shiva Panchakshari Mantra’ initiation - as per Sastras, irrespective
                        of caste, creed, age or sex. This Mantra Deeksha stays lifelong and grants spiritual & materialistic welfare. <br />
                        The Shiva Deeksha programme does not end at a mere one day celebration. Sreemath Hariharapura ensures an
                        all time bond with the devotees who take part in this programme. Every year, for the Shivarathri Pooja, Mruthika
                        Lingas are sent to the all the locations where the Shiva Deeksha programme had been conducted. Devotees at
                        the locality perform Pooja to this Shiva Linga with their own hands on the auspicious Shivarathri night. <br />
                        The Shiva Deeksha Program brings together people from innumerable walks of life in understanding and
                        practicing Sanatana Dharma. This also plants the sense of equanimity and unity in people. Presently, the Shiva
                        Deeksha programme has been conducted at about 1000 centres across the four Indian states of Karnataka,
                        Andhra, Tamil Nadu and Maharashtra, and around 10,00,000 people have benefitted due to this.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="box-img global-img">
                  <img src="assets/img/event/social-activities/1.jpg" alt="event" />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                <div className="box-wrapper">
                  <div className="box-wrapp">
                    <div className="num">
                      <h2 className="box-number">02</h2>
                    </div>
                    <div className="box-content">
                      <h3 className="box-title">
                        <a href="#">VISHWA GAYATRI UPASAK PARISHAT </a>
                      </h3>
                      <p className="box-text">
                        Gayatri Upasana is a very ancient worship that is said to bestow prosperity, courage and harmony. It is also
                        believed that this Upasana improves the memory power, grasping capacity, brilliance and intellect of an
                        individual. The Vishwa Gayatri Upaasak Parishat is a scheme in which women are taught to perform the Gayathri
                        Upasana, by worshipping Vedamatha Gayathri Devi based on Sastras, with Gayathri Sahasranama. Presently
                        around 1,00,000 women in and around South India have learnt this Upaasana.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="box-img global-img">
                  <img src="assets/img/event/social-activities/2.jpg" alt="event" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
};

export default SocialActivities;
